import { ItemsInner } from "@nens/rana/api-v1";

import { FileWithDescriptor } from "@/features/publications";

import { FileDataTypeEnum } from "../enums/file-data-type";

export const PublicationDataTypes = [
  FileDataTypeEnum.Schematisation,
  FileDataTypeEnum.Raster,
  FileDataTypeEnum.Scenario,
  FileDataTypeEnum.Vector,
] as const;

export const isPublicationFile = ({
  type,
  dataType,
}: ItemsInner | FileWithDescriptor | FileWithDescriptor): boolean =>
  type === "file" && !!dataType && ([...PublicationDataTypes] as string[]).includes(dataType);
